import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useCallback } from 'react';
import AccountModalStep from '~/constants/accountModalStep';

type AccountModalParams = {
  callerIdentifier: string;
  modalTitle?: string;
  onSuccess?: () => void;
  step?: AccountModalStep;
};

export default function useOpenAccountModal() {
  const { emit } = useCoreEvents();

  return useCallback(
    ({ callerIdentifier, modalTitle, onSuccess, step }: AccountModalParams) => {
      emit(eventNames.accountModal.open, {
        CallerIdentifier: callerIdentifier,
        EnterEmail: { displayTitle: modalTitle },
        OnAuthenticatedSuccess: onSuccess,
        step
      });
    },
    [emit]
  );
}
